export default __webpack_public_path__ + "static/media/warn100.ebfb3ae7.gif";